<div class="row">
    <div class="col-12 col-md-6 map-wrapper p-0">
        <img [src]="environment.imageCDN + environment.imageFolder + '/' + imagePath" class="img-fluid d-block imageMap" (click)="addInteractionInMap($event)" #imageMap/>
        <div class="overlay"  *ngIf="showSelect"></div>
        <div class="intOnMap"
            *ngFor="let int of intsOnMap"
            [style.top]="int.coordinates.y"
            [style.left]="int.coordinates.x"
            [style.backgroundColor]="int.pending ? '#73BCCA' : '#E97E97'"
            (click)="changeIntOnMap(int)">
            <app-custom-icons [icon]="int?.nodeType ? int?.nodeType +'.svg' : 'interactions.svg'" [color]="'#ffffff'" [size]="'14px'" class="d-inline-block"></app-custom-icons>
            <div class="deleteButton" (click)="deleteIntOnMap(int)" *ngIf="int.pending" >
                <i class="fal fa-trash"></i>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-6 select-wrapper">
        <span *ngIf="!interactions.length">Per posizionare le Interactions sulla mappa devi prima aggiungere prima le Interaction</span>
        <ul class="p-0">
            <li *ngFor="let int of intsOnMap" class="list-style-none" (click)="changeIntOnMap(int)">
                <app-interaction-list-item [interaction]="int"></app-interaction-list-item>
            </li>
        </ul>
        <ng-select *ngIf="showSelect" [ngClass]="'ng-select'" [options]="interactionsSelect" [(ngModel)]="selectedInteraction" (selected)="onSelectInteraction(pendingInt)" [placeholder]="'Seleziona una Interactions'"></ng-select>
    </div>
</div>